import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext, useEffect, useState} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";
import {NativeSelect, TextareaAutosize} from "@mui/material";
import {getQuestionTypes} from "../common/api/WebApi";

export default function ManageQuestionForm({question, handleClose, handleSave, saving, show}) {

  const [context, setContext] = useContext(AppContext);
  const [formInvalid, setFormInvalid] = useState(false);
  const [isNew, setIsNew] = useState(!question?.questionGuid);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(question)
  });

  const handleModalClose = () => {
    handleClose();
  };

  const handleFormSave = (data) => {
    handleSave(data);
  };

  const [questionType, setQuestionType] = useState(question ? parseInt(question.questionTypeId, 10) : 1);
  const [questionTypes, setQuestionTypes] = useState([]);

  useEffect(()=>{
    getQuestionTypes().then((resp)=>{
      setQuestionTypes(resp);
    })
  },[])

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form onSubmit={handleSubmit(handleFormSave)} id={'questionForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{isNew ? 'Create New' : 'Manage'} Question</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      <MDInput
                        variant="outlined" type="text"
                        autoComplete="off" required
                        InputLabelProps={{shrink: true}}
                        {...register('questionLabel')}
                        autoComplete="off"
                        className="form-control" id="questionLabel"
                        label="Question Label"
                        placeholder="Enter Question Label"/>

                    </div>
                  </Col>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group native-margin-fix">
                      <label htmlFor={"state"} className={"native-label mt-n3"}>Question Type</label>
                      {questionTypes?.length &&
                        <NativeSelect
                          autoComplete="off"
                          variant="outlined"
                          id={'questionTypes'} name={'questionTypes'} className={'form-control'}
                          {...register('questionType.id',{
                            valueAsNumber: true,
                            required: true,
                            onChange:(e)=>{
                              setQuestionType(parseInt(e.target.value, 10))
                            }
                          })}>
                          {
                            questionTypes.map((c) =>
                              <option value={c.id} key={c.id}>
                                {c.name}
                              </option>)
                          }
                        </NativeSelect>}
                    </div>
                  </Col>
                </Row>
                <Row className={'mt-4'}>
                  <Col className={'col'} sm={6} xs={12}>
                    <div className="form-group">

                      {questionType === 7 && <>
                        <TextareaAutosize
                          {...register('description')}
                          autoComplete="off"
                          maxLength={255}
                          minRows={3}
                          className="form-control" id="desc"
                          placeholder={'Enter General Text'}/>
                      </>}
                      {questionType !== 7 && <>
                        <MDInput
                          variant="outlined" type="text"
                          autoComplete="off"
                          InputLabelProps={{shrink: true}}
                          {...register('description',{
                            maxLength:2500,
                          })}
                          autoComplete="off"
                          className="form-control" id="description"
                          label="Question Description"
                          placeholder="Enter Question Description"/>
                      </>}

                    </div>
                  </Col>
                  <Col className={'col'} sm={6} xs={12}>
                    <label htmlFor="required">
                      <input type="checkbox"
                             {...register('required')}
                             id="required"/>
                      &nbsp;Required
                    </label>
                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={formInvalid || saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}